
import Vue from 'vue'

const maxLines = 18;

export default Vue.extend({
    props: ['values'],
    data: () => ({opened: false}),
    computed: {
        displayProps() {
            if (this.opened) {
                return this.values;
            } else {
                let count = 0;
                const result = [];

                (this.values as any[]).forEach((el) => {

                    if (count > maxLines - 3) {
                        return;
                    }

                    if (count) {
                        count++;
                    }
                    count++;
                    if (el.props.length <= maxLines - count) {
                        result.push(el);
                        count += el.props.length;
                    } else {
                        result.push({
                            name: el.name,
                            props: el.props.slice(0, maxLines - count),
                        });

                        count = maxLines + 1;
                    }
                });

                return result;
            }
        },
        totalLines() {

            let lines = 0;

            (this.values as any[]).forEach((el, i) => {
                lines += el.props.length + 1 + (i !== 0);
            });

            return lines;
        },
        needShowMore() {
            return (this as any).totalLines > maxLines;
        },
        showMoreText() {
            return this.opened ? 'Свернуть описание' : 'Развернуть описание';
        }
    }
})
